import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    parcoursFormaliteBasePath,
    parcoursFormaliteClientsStepPath,
    parcoursFormaliteContactStepPath,
    parcoursFormaliteDocsStepPath,
    parcoursFormaliteFormaliteStepPath,
    parcoursFormaliteFormStepPath,
    parcoursFormaliteNextFormStepPath,
    parcoursFormalitePrescriberStepPath,
    parcoursFormaliteRecapStepPath,
} from './constants';
import ParcoursFormaliteRoot from './ParcoursFormaliteRoot';
import StepSelectionFormalites from './steps/StepSelectionFormalites';
import StepSelectionClient from './steps/StepSelectionClient';
import StepFormulaires from './steps/StepFormulaires';
import StepRecap from './steps/StepRecap';
import StepDocFirst from './steps/StepDocFirst';
import StepNextForm from './steps/StepNextForm';
import StepPrescriber from './steps/StepPrescriber';
import StepContact from './steps/StepContact';

export const ParcoursFormaliteRouter: RouteObject = {
    path: parcoursFormaliteBasePath,
    element: <ParcoursFormaliteRoot />,
    children: [
        {
            path: parcoursFormalitePrescriberStepPath,
            element: <StepPrescriber />,
        },
        {
            path: parcoursFormaliteContactStepPath,
            element: <StepContact />,
        },
        {
            path: parcoursFormaliteFormaliteStepPath,
            element: <StepSelectionFormalites />,
        },
        {
            path: parcoursFormaliteClientsStepPath,
            element: <StepSelectionClient />,
        },
        {
            path: `${parcoursFormaliteFormStepPath}/:indexPresta/:page`,
            element: <StepFormulaires />,
        },
        {
            path: parcoursFormaliteDocsStepPath,
            element: <StepDocFirst />,
        },
        {
            path: parcoursFormaliteRecapStepPath,
            element: <StepRecap />,
        },
        {
            path: `${parcoursFormaliteNextFormStepPath}/:indexPresta/:page`,
            element: <StepNextForm />,
        },
    ],
};

export const ParcoursFormaliteRouterBack: RouteObject = {
    ...ParcoursFormaliteRouter,
    element: <ParcoursFormaliteRoot back />,
};
